module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.list), function(item, index) {
    return _c('div', {
      staticClass: "service-apply-box app-border-top"
    }, [_c('div', {
      staticClass: "remark-title flex-between"
    }, [_c('span', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      class: 'flex-end title-right status-' + item.admin_status
    }, [_vm._v("\n        " + _vm._s(item.status_name) + "\n      ")])]), _vm._v(" "), _c('div', {
      staticClass: "remark-user flex-between"
    }, [_c('div', {
      staticClass: "remark-user-left flex-start"
    }, [_vm._v(_vm._s(item.user_name))]), _vm._v(" "), _c('div', {
      staticClass: "remark-user-right specification gray"
    }, [_vm._v("\n        " + _vm._s(item.create_time_str) + "\n      ")])]), _vm._v(" "), _c('div', {
      staticClass: "remark-span"
    }, [_vm._v(_vm._s(item.note))]), _vm._v(" "), _c('div', {
      staticClass: "remark-pric remark-prics"
    }, _vm._l((item.pics), function(pic, index) {
      return _c('img', {
        staticClass: "remark-img",
        attrs: {
          "src": pic.url
        }
      })
    }), 0), _vm._v(" "), (item.admin_user_id) ? _c('div', {
      staticClass: "admin-note"
    }, [_c('div', {
      staticClass: "flex-between"
    }, [_c('span', {
      staticClass: "flex-start gray"
    }, [_vm._v(_vm._s(item.admin_user_name))]), _vm._v(" "), _c('span', {
      staticClass: "time gray"
    }, [_vm._v(_vm._s(item.complete_time_string))])]), _vm._v(" "), (item.admin_note) ? _c('div', {
      staticClass: "note"
    }, [_vm._v(_vm._s(item.admin_note))]) : _vm._e()]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "add-btn"
  }, [_c('div', {
    staticClass: "add-b-b"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("我要申请")])], 1)])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9eb5538e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/club/ClubScoreApplyList.vue
// module id = 2563
// module chunks = 0